import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.emplace.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.get-or-insert.js";
import "core-js/modules/esnext.map.get-or-insert-computed.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/es.iterator.map.js";
export default {
    props: {
        modelValue: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            tableData: [],
            total: 0,
            selectedRows: [],
            supplierId: "",
            queryInfo: {
                pageNo: 1,
                pageSize: 10,
                keywords: "",
                goods_type: 3,
                supplier_id: ""
            },
            isLoading: false
        };
    },
    mounted () {
        this.getDataList();
    },
    computed: {
        // 当前分类类型为 1（套餐商品，原代码中 type=4 会转换为 1）
        currentType () {
            return 1;
        }
    },
    watch: {
        modelValue: {
            handler (newVal) {
                // 从全局数组中过滤出当前分类的项
                if (Array.isArray(newVal)) {
                    this.selectedRows = newVal.filter((item)=>item.type === this.currentType);
                } else if (newVal && newVal.type === this.currentType) {
                    this.selectedRows = [
                        newVal
                    ];
                } else {
                    this.selectedRows = [];
                }
                this.$nextTick(()=>{
                    this.setTableSelection();
                });
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        handleSupplierChange () {
            this.queryInfo.supplier_id = this.supplierId || "";
            this.queryInfo.pageNo = 1;
            this.getDataList();
        },
        //! 搜索
        handleSearch () {
            this.queryInfo.pageNo = 1;
            this.getDataList();
        },
        //! 分页功能
        paginationChange (page) {
            this.queryInfo.pageNo = page;
            this.getDataList();
        },
        //! 页码切换
        pageSizeChange (size) {
            this.queryInfo.pageSize = size;
            this.getDataList();
        },
        //! 设置表格选中状态
        setTableSelection () {
            if (this.$refs.table && this.$refs.table.$refs.table) {
                this.$refs.table.$refs.table.clearSelection();
                this.selectedRows.forEach((selectedRow)=>{
                    const row = this.tableData.find((item)=>item.id === selectedRow.id);
                    if (row) {
                        this.$refs.table.$refs.table.toggleRowSelection(row, true);
                    }
                });
            }
        },
        //! 更新全局选中项数组
        updateGlobalSelection () {
            // 获取全局数组
            const globalArray = Array.isArray(this.modelValue) ? [
                ...this.modelValue
            ] : this.modelValue ? [
                this.modelValue
            ] : [];
            // 移除当前分类的所有项
            const otherItems = globalArray.filter((item)=>item.type !== this.currentType);
            // 合并当前分类的新选中项
            const newGlobalArray = [
                ...otherItems,
                ...this.selectedRows
            ];
            this.$emit('update:modelValue', newGlobalArray);
        },
        //! 单选事件
        handleSelect (selection, row) {
            const isSelected = selection.includes(row);
            if (isSelected) {
                // 添加选中
                const exists = this.selectedRows.find((item)=>item.id === row.id);
                if (!exists) {
                    const obj = {
                        title: row.title,
                        type: this.currentType,
                        id: row.id
                    };
                    this.selectedRows.push(obj);
                }
            } else {
                // 取消选中
                const index = this.selectedRows.findIndex((item)=>item.id === row.id);
                if (index > -1) {
                    this.selectedRows.splice(index, 1);
                }
            }
            this.updateGlobalSelection();
        },
        //! 全选事件
        handleSelectAll (selection) {
            if (selection.length > 0) {
                // 拉取全部数据，保证跨页选中
                this.fetchAllDataAndSelect();
            } else {
                // 取消全选则清空当前类型
                this.selectedRows = [];
                this.updateGlobalSelection();
            }
        },
        // 拉取全部数据并选中
        async fetchAllDataAndSelect () {
            const params = {
                ...this.queryInfo,
                pageNo: 1,
                pageSize: this.total || this.queryInfo.pageSize
            };
            const res = await this.$API.goods.goods.listSimple.get(params);
            const allData = res?.data || [];
            const map = new Map(this.selectedRows.map((item)=>[
                    item.id,
                    item
                ]));
            allData.forEach((row)=>{
                map.set(row.id, {
                    title: row.title,
                    type: this.currentType,
                    id: row.id
                });
            });
            this.selectedRows = Array.from(map.values());
            this.updateGlobalSelection();
            this.$nextTick(()=>{
                this.setTableSelection();
            });
        },
        async getDataList () {
            this.isLoading = true;
            let res = await this.$API.goods.goods.listSimple.get(this.queryInfo);
            this.isLoading = false;
            this.tableData = res?.data || [];
            this.total = res?.total || 0;
            this.$nextTick(()=>{
                this.setTableSelection();
            });
        }
    }
};
